import {SEARCH_QUERY} from '../../../constants/searchQuery';

export const setReferralCode = value => {
  const params = new URLSearchParams();
  params.set(SEARCH_QUERY.REFERRAL_CODE, value);

  return `?${params.toString()}`;
};
